<div class="container-fluid mt-2 mb-2">
    <div class="row mt-2">
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>
    <div class="row mt-3">
        <ng-container *ngFor="let pm of paymentMethods">
            <div class="col-3">
                <mat-card class="mat-elevation-z6">
                    <mat-card-header class="row justify-content-center">
                        <div class="row">
                            <div class="col">
                                <img *ngIf="pm.card.brand.includes('mastercard')" height="35"
                                    src="../../../assets/img/mastercard.svg" />
                                <img *ngIf="pm.card.brand.includes('visa')" height="35"
                                    src="../../../assets/img/visa.svg" />
                                <img *ngIf="pm.card.brand.includes('disc')" height="35"
                                    src="../../../assets/img/discover.svg" />
                                <img *ngIf="pm.card.brand.includes('amex')" height="35"
                                    src="../../../assets/img/amex.svg" />
                            </div>
                            <div class="col text-align-end"
                                *ngIf="customer.invoice_settings.default_payment_method === pm.id">
                                <p class="pull-right"><strong>Default</strong></p>
                            </div>
                        </div>
                    </mat-card-header>
                    <hr />
                    <mat-card-content class="row mb-3">
                        <div class="col-12">
                            <p><strong>Exp:</strong> {{pm.card.expMonth}}/{{pm.card.exp_year}}</p>
                        </div>
                        <div class="col-12">
                            <p><strong>Card Number:</strong> **** **** **** {{pm.card.last4}}</p>
                        </div>
                        <div class="col-12">
                            <p><strong>Name:</strong> {{pm.billing_details.name}}</p>
                        </div>
                    </mat-card-content>
                    <mat-card-actions class="row">
                        <div class="col pull-right">
                            <button mat-stroked-button class="w-100" matTooltip="Edit Payment Method"
                                (click)="editPaymentMethod(pm)"><mat-icon>edit</mat-icon>&nbsp;Edit</button>
                        </div>
                        <div class="col pull-right">
                            <button mat-stroked-button class="warning w-100" matTooltip="Delete Payment Method"
                                (click)="deletePaymentMethod(pm.id)" [disabled]="paymentMethods.length === 1"><mat-icon>clear</mat-icon>&nbsp;Delete</button>
                        </div>
                    </mat-card-actions>
                </mat-card>
            </div>
        </ng-container>
    </div>
    <div class="row" *ngIf="paymentMethods.length === 0 && isLoading === false">
        <div class="col">
            <h2>No Payment Methods</h2>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col">
            <button mat-raised-button (click)="addPaymentMethod()">Add</button>
        </div>
    </div>
</div>